<template>
  <v-row dense>
    <v-col cols="12" md="6">
      <time-picker
        :value="getTimeString('start')"
        :label="$t('from')"
        :minute-interval="15"
        :hide-details="true"
        @input="setTimeString('start', $event)"
      />
    </v-col>
    <v-col cols="12" md="6">
      <time-picker
        :value="getTimeString('end')"
        :label="$t('to')"
        :minute-interval="15"
        :hide-details="true"
        @input="setTimeString('end', $event)"
      />
    </v-col>
    <v-col cols="12" md="6">
      <v-checkbox
        :label="$t('customer_can_set_delivery_time')"
        :false-value="0"
        :true-value="1"
        v-model.number="settings.check_delivery_time"
      />
    </v-col>
  </v-row>
</template>

<script>
import TimePicker from "@/components/global/pickers/TimePicker.vue";
import hasTimeValidation from "@/mixins/hasTimeValidation";

export default {
  name: "GuestDeliveryTimeSection",
  mixins: [hasTimeValidation],
  components: {
    TimePicker,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    deliveryFrom: {
      type: Array,
      required: true,
    },
    deliveryTo: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getTimeString(type) {
      if (type === "start") {
        const hours = this.settings.delivery_from_hour;
        const minutes = this.settings.delivery_from_min;
        if (!this.isValidTimePair(hours, minutes)) return "";
        return `${this.padTime(hours)}:${this.padTime(minutes)}`;
      }
      if (type === "end") {
        const hours = this.settings.delivery_to_hour;
        const minutes = this.settings.delivery_to_min;
        if (!this.isValidTimePair(hours, minutes)) return "";
        return `${this.padTime(hours)}:${this.padTime(minutes)}`;
      }
      return "";
    },
    setTimeString(type, value) {
      if (!value) {
        if (type === "start") {
          this.settings.delivery_from_hour = "";
          this.settings.delivery_from_min = "";
        }
        if (type === "end") {
          this.settings.delivery_to_hour = "";
          this.settings.delivery_to_min = "";
        }
        return;
      }
      const parsed = this.parseTimeValue(value);
      if (!parsed) {
        if (type === "start") {
          this.settings.delivery_from_hour = "";
          this.settings.delivery_from_min = "";
        }
        if (type === "end") {
          this.settings.delivery_to_hour = "";
          this.settings.delivery_to_min = "";
        }
        return;
      }
      const normalizedHours = parsed.hours;
      const normalizedMinutes = parsed.minutes;

      if (type === "start") {
        this.settings.delivery_from_hour = normalizedHours;
        this.settings.delivery_from_min = normalizedMinutes;
      }
      if (type === "end") {
        this.settings.delivery_to_hour = normalizedHours;
        this.settings.delivery_to_min = normalizedMinutes;
      }
    },
  },
};
</script>
